/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * API for playing pre-recorded Media into a Twilio Video Room
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
/**
 *
 */
export class AudioApi extends runtime.BaseAPI {
    /**
     * Stop Audio
     * Stop Audio
     */
    changeVolumeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['conferenceId'] == null) {
                throw new runtime.RequiredError('conferenceId', 'Required parameter "conferenceId" was null or undefined when calling changeVolume().');
            }
            if (requestParameters['volume'] == null) {
                throw new runtime.RequiredError('volume', 'Required parameter "volume" was null or undefined when calling changeVolume().');
            }
            const queryParameters = {};
            if (requestParameters['conferenceId'] != null) {
                queryParameters['conferenceId'] = requestParameters['conferenceId'];
            }
            if (requestParameters['volume'] != null) {
                queryParameters['volume'] = requestParameters['volume'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/playback/audio/volume`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Stop Audio
     * Stop Audio
     */
    changeVolume(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.changeVolumeRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Gets application cookie for the specified conference- stickying future requests to the correct instance
     * Get application cookie
     */
    getApplicationCookieRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['conferenceId'] == null) {
                throw new runtime.RequiredError('conferenceId', 'Required parameter "conferenceId" was null or undefined when calling getApplicationCookie().');
            }
            const queryParameters = {};
            if (requestParameters['conferenceId'] != null) {
                queryParameters['conferenceId'] = requestParameters['conferenceId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/application-cookie`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Gets application cookie for the specified conference- stickying future requests to the correct instance
     * Get application cookie
     */
    getApplicationCookie(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getApplicationCookieRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Play Audio
     * Play Audio
     */
    playRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['url'] == null) {
                throw new runtime.RequiredError('url', 'Required parameter "url" was null or undefined when calling play().');
            }
            if (requestParameters['conferenceId'] == null) {
                throw new runtime.RequiredError('conferenceId', 'Required parameter "conferenceId" was null or undefined when calling play().');
            }
            if (requestParameters['accountSid'] == null) {
                throw new runtime.RequiredError('accountSid', 'Required parameter "accountSid" was null or undefined when calling play().');
            }
            if (requestParameters['loop'] == null) {
                throw new runtime.RequiredError('loop', 'Required parameter "loop" was null or undefined when calling play().');
            }
            const queryParameters = {};
            if (requestParameters['url'] != null) {
                queryParameters['url'] = requestParameters['url'];
            }
            if (requestParameters['conferenceId'] != null) {
                queryParameters['conferenceId'] = requestParameters['conferenceId'];
            }
            if (requestParameters['accountSid'] != null) {
                queryParameters['accountSid'] = requestParameters['accountSid'];
            }
            if (requestParameters['loop'] != null) {
                queryParameters['loop'] = requestParameters['loop'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/playback/audio/play`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Play Audio
     * Play Audio
     */
    play(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.playRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Stop Audio
     * Stop Audio
     */
    stopRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['conferenceId'] == null) {
                throw new runtime.RequiredError('conferenceId', 'Required parameter "conferenceId" was null or undefined when calling stop().');
            }
            const queryParameters = {};
            if (requestParameters['conferenceId'] != null) {
                queryParameters['conferenceId'] = requestParameters['conferenceId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/playback/audio/stop`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Stop Audio
     * Stop Audio
     */
    stop(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.stopRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Toggle Audio
     * Toggle Audio
     */
    toggleRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['conferenceId'] == null) {
                throw new runtime.RequiredError('conferenceId', 'Required parameter "conferenceId" was null or undefined when calling toggle().');
            }
            const queryParameters = {};
            if (requestParameters['conferenceId'] != null) {
                queryParameters['conferenceId'] = requestParameters['conferenceId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // ClientAuthorizer authentication
            }
            const response = yield this.request({
                path: `/playback/audio/toggle`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Toggle Audio
     * Toggle Audio
     */
    toggle(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.toggleRaw(requestParameters, initOverrides);
        });
    }
}
